export default function ArrowStage({className}) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M14.8572 24.375L22.4947 13L14.8572 1.625H2.11719L11.0303 13L2.11719 24.375H14.8572Z" fill="#2B306C"/>
            <script xmlns=""/>
        </svg>
    )
}